// extracted by mini-css-extract-plugin
module.exports = {"tabTriggerCard":"TabTriggerCard_tabTriggerCard__PDPok","icon":"TabTriggerCard_icon__QieGZ","label":"TabTriggerCard_label__MzF4r","banner":"TabTriggerCard_banner__6i4k0"};